export default __webpack_public_path__ + "static/media/img4.9bf77964.jpg";